@if (config) {
  <div class="chat--button">
    @if (config?.type === chatTypes.liveagent) {
      <!-- inline styles usually should never be done.... this is required for integration with salesforce liveagent -->
      <div
        style="display: none"
        [id]="liveAgentOnlineButtonText"
        (click)="handleStartingChat()"
        data-test-id="chatLiveAgentOnlineButton"
      >
        <ng-container *ngTemplateOutlet="onlineView"></ng-container>
      </div>
      <div
        style="display: none"
        [id]="liveAgentOfflineButtonText"
        data-test-id="chatLiveAgentOfflineButton"
      >
        <ng-container *ngTemplateOutlet="offlineView"></ng-container>
      </div>
    }
  </div>
}

<ng-template #onlineView>
  <zip-button
    level="high"
    icon="chat_active"
    data-test-id="chatOnlineZipButton"
  >
  </zip-button>
</ng-template>

<ng-template #offlineView>
  <zip-button
    [disabled]="true"
    level="low"
    icon="chat"
    data-test-id="chatOfflineZipButton"
  >
  </zip-button>
</ng-template>
